import { atom } from 'jotai';

export const dealIdentifierState = atom<string>('');
